<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtKey"  placeholder="公示名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">
                <el-radio-group v-model="pgData.txtKey2" @change="searchHandler">
                    <el-radio-button label="1">未审核公示</el-radio-button>
                    <el-radio-button label="6">已审核公示</el-radio-button>
                    <el-radio-button label="9">已发布公示</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </my-search>
        <my-table :data="tableData" :height="tableHeight" :search="pgData">
            <el-table-column label="公示名称" prop="gsname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="公示类型" prop="gstypename" sortable width="150"></el-table-column>
            <el-table-column label="开始时间" prop="gsstarttime" sortable width="150"></el-table-column>
            <el-table-column label="结束时间" prop="gsendtime" sortable width="150"></el-table-column>
            <el-table-column label="提交时间" prop="gstjtime" sortable width="150"></el-table-column>
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <state-list :row="scope.row" :config="STATE_CONF" v-if="scope.row.shbj!=='3'"></state-list>
                    <my-tag type="danger" v-if="scope.row.shbj==='3'">
                        <div class="reason">
                            退回：{{scope.row.by2}}
                        </div>    
                    </my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/auditzbhxrgs/get_list.json`">
        </my-pagination>

       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import FormAudit from './sub-pages/form-audit'

import STATE_CONF from './config/zbhxrgs-state'
import BTN_CONF from './config/zbhxrgs-btn-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {FormAudit},
    data() {
        return{
            pgData: {
                txtKey:'',
                txtKey2: '1',
                sortname:'a.shbj'
            },
            dialogTitle: '',
            dialogVisible: false,
            dialogComponent: '',


            STATE_CONF,
            BTN_CONF,

        }
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {

    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
